// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"150577d2","977":"26ea2d3a"}[chunkId] + ".chunk.js";
};